import { css } from '@emotion/react';
import t from 'react-translate';
import Avatar from 'athena/components/mentoring-program/avatar';
import { CellProps } from './types';


const styles = css`
  .name-details {
    flex: 1;
    min-width: 0;
  }
`;

const NameCell = ({ cell, className }: CellProps) => {
  const user = cell.getValue();

  return (
    <div css={styles} className={`d-flex align-items-center ${className}`}>
      <Avatar user={user} className='flex-shrink-0 mr-2' />
      <div className='name-details d-flex flex-column justify-content-center align-items-stretch'>
        <div className='text-medium bold ellipsis'>
          {t.USERS.FULL_NAME(user.firstName, user.lastName)}
        </div>
        <div className='text-small color-dark-gray three-line-ellipsis'>
          {user.email}
        </div>
      </div>
    </div>
  );
};

export default NameCell;
